export const environment = {
	questionnaireFormUrl: `${process.env.REACT_APP_QUESTIONNAIRE_ROOT_URL}`,
	apiUrl: `${process.env.REACT_APP_API_URL}survey-designer/`,
	questionnaireApiUrl: `${process.env.REACT_APP_API_URL}questionnaire/`,
	surveyAnalyticsApiUrl: `${process.env.REACT_APP_API_URL}survey-analytics/`,
};
